import { render, staticRenderFns } from "./pesquisar.vue?vue&type=template&id=51c874aa&scoped=true"
import script from "./pesquisar.vue?vue&type=script&lang=js"
export * from "./pesquisar.vue?vue&type=script&lang=js"
import style0 from "./pesquisar.vue?vue&type=style&index=0&id=51c874aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c874aa",
  null
  
)

export default component.exports